import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  orgId?: string;
  locationIds?: string[];
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/refresh-access')({
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    const rawLocationIds = search.locationIds;
    const normalizedLocationIds = Array.isArray(rawLocationIds)
      ? rawLocationIds.flatMap((id) =>
          String(id)
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
        )
      : undefined;

    return {
      orgId: search.orgId,
      locationIds: normalizedLocationIds && normalizedLocationIds.length > 0 ? normalizedLocationIds : undefined,
    };
  },
});
